/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

import * as APITypes from "../API";
type GeneratedQuery<InputType, OutputType> = string & {
  __generatedQueryInput: InputType;
  __generatedQueryOutput: OutputType;
};

export const listUsers = /* GraphQL */ `query ListUsers {
  listUsers {
    Username
    Attributes {
      Name
      Value
      __typename
    }
    UserCreateDate
    UserLastModifiedDate
    Enabled
    UserStatus
    __typename
  }
}
` as GeneratedQuery<APITypes.ListUsersQueryVariables, APITypes.ListUsersQuery>;
export const listUserGroups = /* GraphQL */ `query ListUserGroups {
  listUserGroups {
    statusCode
    body
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListUserGroupsQueryVariables,
  APITypes.ListUserGroupsQuery
>;
export const listUserRoles = /* GraphQL */ `query ListUserRoles {
  listUserRoles {
    statusCode
    body
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListUserRolesQueryVariables,
  APITypes.ListUserRolesQuery
>;
export const listPriorities = /* GraphQL */ `query ListPriorities {
  listPriorities {
    statusCode
    body
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListPrioritiesQueryVariables,
  APITypes.ListPrioritiesQuery
>;
export const listAuditTrails = /* GraphQL */ `query ListAuditTrails {
  listAuditTrails {
    statusCode
    body
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListAuditTrailsQueryVariables,
  APITypes.ListAuditTrailsQuery
>;
export const getAuditRecords = /* GraphQL */ `query GetAuditRecords {
  getAuditRecords {
    code
    msg
    result
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetAuditRecordsQueryVariables,
  APITypes.GetAuditRecordsQuery
>;
export const listBatchesbyUser =
  /* GraphQL */ `query ListBatchesbyUser($username: String) {
  listBatchesbyUser(username: $username) {
    statusCode
    body
    __typename
  }
}
` as GeneratedQuery<
    APITypes.ListBatchesbyUserQueryVariables,
    APITypes.ListBatchesbyUserQuery
  >;
export const listBatchItem =
  /* GraphQL */ `query ListBatchItem($batch_id: String, $batch_item_id: Int) {
  listBatchItem(batch_id: $batch_id, batch_item_id: $batch_item_id) {
    statusCode
    body
    __typename
  }
}
` as GeneratedQuery<
    APITypes.ListBatchItemQueryVariables,
    APITypes.ListBatchItemQuery
  >;
export const listBenchmarkData = /* GraphQL */ `query ListBenchmarkData {
  listBenchmarkData {
    statusCode
    body
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListBenchmarkDataQueryVariables,
  APITypes.ListBenchmarkDataQuery
>;
export const listModelData = /* GraphQL */ `query ListModelData {
  listModelData {
    statusCode
    body
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListModelDataQueryVariables,
  APITypes.ListModelDataQuery
>;
export const listBenchmarkResults =
  /* GraphQL */ `query ListBenchmarkResults($benchmarkCode: String!) {
  listBenchmarkResults(benchmarkCode: $benchmarkCode) {
    statusCode
    body
    __typename
  }
}
` as GeneratedQuery<
    APITypes.ListBenchmarkResultsQueryVariables,
    APITypes.ListBenchmarkResultsQuery
  >;
export const listBenchmarkJobs = /* GraphQL */ `query ListBenchmarkJobs {
  listBenchmarkJobs {
    statusCode
    body
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListBenchmarkJobsQueryVariables,
  APITypes.ListBenchmarkJobsQuery
>;
export const listDeploymentJobs = /* GraphQL */ `query ListDeploymentJobs {
  listDeploymentJobs {
    statusCode
    body
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListDeploymentJobsQueryVariables,
  APITypes.ListDeploymentJobsQuery
>;
export const listCompatibleModels = /* GraphQL */ `query ListCompatibleModels {
  listCompatibleModels {
    statusCode
    body
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListCompatibleModelsQueryVariables,
  APITypes.ListCompatibleModelsQuery
>;
export const getLastLabeledBatchItemByUser =
  /* GraphQL */ `query GetLastLabeledBatchItemByUser($username: String, $batch_id: String) {
  getLastLabeledBatchItemByUser(username: $username, batch_id: $batch_id) {
    statusCode
    body
    __typename
  }
}
` as GeneratedQuery<
    APITypes.GetLastLabeledBatchItemByUserQueryVariables,
    APITypes.GetLastLabeledBatchItemByUserQuery
  >;
export const getLabelFilesByFileName =
  /* GraphQL */ `query GetLabelFilesByFileName($filename: String) {
  getLabelFilesByFileName(filename: $filename) {
    statusCode
    body
    __typename
  }
}
` as GeneratedQuery<
    APITypes.GetLabelFilesByFileNameQueryVariables,
    APITypes.GetLabelFilesByFileNameQuery
  >;
export const getTeaRetinaImageUploadDetail =
  /* GraphQL */ `query GetTeaRetinaImageUploadDetail(
  $collection: String!
  $filters: AWSJSON
  $action: String!
  $page_number: Int
  $page_size: Int
) {
  getTeaRetinaImageUploadDetail(
    collection: $collection
    filters: $filters
    action: $action
    page_number: $page_number
    page_size: $page_size
  ) {
    statusCode
    body
    __typename
  }
}
` as GeneratedQuery<
    APITypes.GetTeaRetinaImageUploadDetailQueryVariables,
    APITypes.GetTeaRetinaImageUploadDetailQuery
  >;
export const getTeaRetinaFileUploadDetail =
  /* GraphQL */ `query GetTeaRetinaFileUploadDetail(
  $collection: String!
  $filter_criteria: AWSJSON!
  $action: String
  $page: Int
  $page_size: Int
) {
  getTeaRetinaFileUploadDetail(
    collection: $collection
    filter_criteria: $filter_criteria
    action: $action
    page: $page
    page_size: $page_size
  ) {
    code
    result
    __typename
  }
}
` as GeneratedQuery<
    APITypes.GetTeaRetinaFileUploadDetailQueryVariables,
    APITypes.GetTeaRetinaFileUploadDetailQuery
  >;
export const postConfigurationsData =
  /* GraphQL */ `query PostConfigurationsData(
  $user_email: String
  $config_name: String
  $config_file: String
) {
  postConfigurationsData(
    user_email: $user_email
    config_name: $config_name
    config_file: $config_file
  ) {
    code
    msg
    result
    __typename
  }
}
` as GeneratedQuery<
    APITypes.PostConfigurationsDataQueryVariables,
    APITypes.PostConfigurationsDataQuery
  >;
export const getConfigurationsData =
  /* GraphQL */ `query GetConfigurationsData($user_email: String, $config_name: String) {
  getConfigurationsData(user_email: $user_email, config_name: $config_name) {
    code
    msg
    result
    __typename
  }
}
` as GeneratedQuery<
    APITypes.GetConfigurationsDataQueryVariables,
    APITypes.GetConfigurationsDataQuery
  >;
export const getUploadedFiles = /* GraphQL */ `query GetUploadedFiles {
  getUploadedFiles {
    request_id
    request_date_time
    file_name
    status
    description
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetUploadedFilesQueryVariables,
  APITypes.GetUploadedFilesQuery
>;
export const getBrokers = /* GraphQL */ `query GetBrokers {
  getBrokers {
    broker_name
    broker_code
    broker_url
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetBrokersQueryVariables,
  APITypes.GetBrokersQuery
>;
export const getsellingmarks = /* GraphQL */ `query Getsellingmarks {
  getsellingmarks
}
` as GeneratedQuery<
  APITypes.GetsellingmarksQueryVariables,
  APITypes.GetsellingmarksQuery
>;
export const getLabelFileProgressByUser =
  /* GraphQL */ `query GetLabelFileProgressByUser(
  $filters: LabelFileFilter
  $page_size: Int!
  $page_number: Int!
) {
  getLabelFileProgressByUser(
    filters: $filters
    page_size: $page_size
    page_number: $page_number
  ) {
    statusCode
    body
    __typename
  }
}
` as GeneratedQuery<
    APITypes.GetLabelFileProgressByUserQueryVariables,
    APITypes.GetLabelFileProgressByUserQuery
  >;
export const getLabelFileProgressByUserCount =
  /* GraphQL */ `query GetLabelFileProgressByUserCount($filters: LabelFileFilter) {
  getLabelFileProgressByUserCount(filters: $filters) {
    statusCode
    body
    __typename
  }
}
` as GeneratedQuery<
    APITypes.GetLabelFileProgressByUserCountQueryVariables,
    APITypes.GetLabelFileProgressByUserCountQuery
  >;
export const getLabelFilesCount = /* GraphQL */ `query GetLabelFilesCount {
  getLabelFilesCount {
    statusCode
    body
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetLabelFilesCountQueryVariables,
  APITypes.GetLabelFilesCountQuery
>;
export const getLatestModel =
  /* GraphQL */ `query GetLatestModel($model_type: String!) {
  getLatestModel(model_type: $model_type)
}
` as GeneratedQuery<
    APITypes.GetLatestModelQueryVariables,
    APITypes.GetLatestModelQuery
  >;
export const getLatestModelDetails =
  /* GraphQL */ `query GetLatestModelDetails($model_type: String!, $model_name: String!) {
  getLatestModelDetails(model_type: $model_type, model_name: $model_name)
}
` as GeneratedQuery<
    APITypes.GetLatestModelDetailsQueryVariables,
    APITypes.GetLatestModelDetailsQuery
  >;
export const documentDBAction = /* GraphQL */ `query DocumentDBAction(
  $collection: String!
  $action_type: String!
  $data: AWSJSON
  $filters: AWSJSON
  $page_number: Int
  $page_size: Int
) {
  documentDBAction(
    collection: $collection
    action_type: $action_type
    data: $data
    filters: $filters
    page_number: $page_number
    page_size: $page_size
  ) {
    statusCode
    body
    __typename
  }
}
` as GeneratedQuery<
  APITypes.DocumentDBActionQueryVariables,
  APITypes.DocumentDBActionQuery
>;
export const getWeeks =
  /* GraphQL */ `query GetWeeks($year: Int!, $service: String!) {
  getWeeks(year: $year, service: $service) {
    week_numbers
    __typename
  }
}
` as GeneratedQuery<APITypes.GetWeeksQueryVariables, APITypes.GetWeeksQuery>;
export const listYears = /* GraphQL */ `query ListYears($service: String!) {
  listYears(service: $service) {
    year_folders
    __typename
  }
}
` as GeneratedQuery<APITypes.ListYearsQueryVariables, APITypes.ListYearsQuery>;
export const listBrokersFromAuction =
  /* GraphQL */ `query ListBrokersFromAuction($year: Int!, $sale_code: Int!) {
  listBrokersFromAuction(year: $year, sale_code: $sale_code) {
    brokers
    __typename
  }
}
` as GeneratedQuery<
    APITypes.ListBrokersFromAuctionQueryVariables,
    APITypes.ListBrokersFromAuctionQuery
  >;
export const listLotsFromAuction =
  /* GraphQL */ `query ListLotsFromAuction($year: Int!, $sale_code: Int!, $broker: String!) {
  listLotsFromAuction(year: $year, sale_code: $sale_code, broker: $broker) {
    lot_nos
    __typename
  }
}
` as GeneratedQuery<
    APITypes.ListLotsFromAuctionQueryVariables,
    APITypes.ListLotsFromAuctionQuery
  >;
export const getMixingDataBySale = /* GraphQL */ `
  query getMixingDataBySale($table: String!, $sale: String!) {
    getMixingDataBySale(table: $table, sale: $sale) {
      code
      msg
      result
      __typename
    }
  }
` as GeneratedQuery<
  APITypes.GetMixingDataBySaleQueryVariables,
  APITypes.GetMixingDataBySaleQuery
>;

export const getAllMixingStatus = /* GraphQL */ `
  query getAllMixingStatus {
    getAllMixingStatus {
      user
      sale_code
      requested_count
      status
      collected_count
      mixed_pairs
      starting_box
      image_folder
      check_missed
      __typename
    }
  }
` as GeneratedQuery<
  APITypes.GetAllMixingStatusQueryVariables,
  APITypes.GetAllMixingStatusQuery
>;

export const getRepeatedCount = /* GraphQL */ `
  query getMixingRepeatedCount($sale: String!) {
    getMixingRepeatedCount(sale: $sale) {
      ind
      count
      __typename
    }
  }
` as GeneratedQuery<
  APITypes.GetMixingRepeatedCountQueryVariables,
  APITypes.GetMixingRepeatedCountQuery
>;

export const getCatalogYears = /* GraphQL */ `query GetCatalogYears {
  getCatalogYears {
    statusCode
    body
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetCatalogYearsQueryVariables,
  APITypes.GetCatalogYearsQuery
>;
export const getCatalogSaleCodes =
  /* GraphQL */ `query GetCatalogSaleCodes($year: Int!) {
  getCatalogSaleCodes(year: $year) {
    statusCode
    body
    __typename
  }
}
` as GeneratedQuery<
    APITypes.GetCatalogSaleCodesQueryVariables,
    APITypes.GetCatalogSaleCodesQuery
  >;
export const getCatalogLotsByBroker =
  /* GraphQL */ `query GetCatalogLotsByBroker(
  $year: Int!
  $saleCode: Int!
  $brokerCode: String!
) {
  getCatalogLotsByBroker(
    year: $year
    saleCode: $saleCode
    brokerCode: $brokerCode
  ) {
    statusCode
    body
    __typename
  }
}
` as GeneratedQuery<
    APITypes.GetCatalogLotsByBrokerQueryVariables,
    APITypes.GetCatalogLotsByBrokerQuery
  >;

export const listAnnotationJobs =
  /* GraphQL */ `query ListAnnotationJobs($userEmail: String!) {
  listAnnotationJobs(userEmail: $userEmail) {
    id
    name
    assigned_users
    total_files
    assigned_by
    allowed_label_ids
    user_status
    completed_count
    __typename
  }
}
` as GeneratedQuery<
    APITypes.ListAnnotationJobsQueryVariables,
    APITypes.ListAnnotationJobsQuery
  >;
export const listAllAnnotationJobs =
  /* GraphQL */ `query ListAllAnnotationJobs {
  listAllAnnotationJobs {
    id
    name
    assigned_users
    user_statuses
    total_files
    assigned_by
    allowed_label_ids
    completed_count
    __typename
  }
}
` as GeneratedQuery<
    APITypes.ListAllAnnotationJobsQueryVariables,
    APITypes.ListAllAnnotationJobsQuery
  >;
export const getAnnotationRecords =
  /* GraphQL */ `query GetAnnotationRecords($jobId: Int!, $userName: String!) {
  getAnnotationRecords(jobId: $jobId, userName: $userName) {
    id
    path
    question
    annotation_files_id
    is_completed
    status
    __typename
  }
}
` as GeneratedQuery<
    APITypes.GetAnnotationRecordsQueryVariables,
    APITypes.GetAnnotationRecordsQuery
  >;
export const getAnnotationResults =
  /* GraphQL */ `query GetAnnotationResults($recordId: Int!, $userName: String!) {
  getAnnotationResults(recordId: $recordId, userName: $userName) {
    id
    labels_id
    coordinates
    status
    __typename
  }
}
` as GeneratedQuery<
    APITypes.GetAnnotationResultsQueryVariables,
    APITypes.GetAnnotationResultsQuery
  >;
export const listAnnotationLabels = /* GraphQL */ `query ListAnnotationLabels {
  listAnnotationLabels {
    id
    name
    color
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListAnnotationLabelsQueryVariables,
  APITypes.ListAnnotationLabelsQuery
>;
export const GetAllLabelFiles = /* GraphQL */ `query GetAllLabelFiles(
  $username: String
  $fileId: String
  $fileName: String
  $status: Boolean
) {
  GetAllLabelFiles(
    username: $username
    fileId: $fileId
    fileName: $fileName
    status: $status
  )
}
` as GeneratedQuery<
  APITypes.GetAllLabelFilesQueryVariables,
  APITypes.GetAllLabelFilesQuery
>;
export const LabelingGetAllLabelFiles =
  /* GraphQL */ `query LabelingGetAllLabelFiles(
  $username: String
  $fileId: String
  $fileName: String
  $status: Boolean
) {
  LabelingGetAllLabelFiles(
    username: $username
    fileId: $fileId
    fileName: $fileName
    status: $status
  )
}
` as GeneratedQuery<
    APITypes.LabelingGetAllLabelFilesQueryVariables,
    APITypes.LabelingGetAllLabelFilesQuery
  >;
export const GetAssignedFiles =
  /* GraphQL */ `query GetAssignedFiles($username: String!) {
  GetAssignedFiles(username: $username)
}
` as GeneratedQuery<
    APITypes.GetAssignedFilesQueryVariables,
    APITypes.GetAssignedFilesQuery
  >;
export const LabelingGetAssignedFiles =
  /* GraphQL */ `query LabelingGetAssignedFiles($username: String!) {
  LabelingGetAssignedFiles(username: $username)
}
` as GeneratedQuery<
    APITypes.LabelingGetAssignedFilesQueryVariables,
    APITypes.LabelingGetAssignedFilesQuery
  >;
export const GetAssignedFileRecord = /* GraphQL */ `query GetAssignedFileRecord(
  $fileId: String!
  $recordId: Int!
  $username: String!
) {
  GetAssignedFileRecord(
    fileId: $fileId
    recordId: $recordId
    username: $username
  )
}
` as GeneratedQuery<
  APITypes.GetAssignedFileRecordQueryVariables,
  APITypes.GetAssignedFileRecordQuery
>;
export const LabelingGetAssignedFileRecord =
  /* GraphQL */ `query LabelingGetAssignedFileRecord(
  $fileId: String!
  $recordId: Int!
  $username: String!
) {
  LabelingGetAssignedFileRecord(
    fileId: $fileId
    recordId: $recordId
    username: $username
  )
}
` as GeneratedQuery<
    APITypes.LabelingGetAssignedFileRecordQueryVariables,
    APITypes.LabelingGetAssignedFileRecordQuery
  >;
export const LabelingGetJobTypes = /* GraphQL */ `query LabelingGetJobTypes {
  LabelingGetJobTypes
}
` as GeneratedQuery<
  APITypes.LabelingGetJobTypesQueryVariables,
  APITypes.LabelingGetJobTypesQuery
>;

export const getGradesForSale = /* GraphQL */ `query GetGradesForSale(
  $year: Int!
  $saleCode: Int!
  $brokerCode: String!
) {
  getGradesForSale(
    year: $year
    saleCode: $saleCode
    brokerCode: $brokerCode
  ) {
    broker_code
    lot_no
    grade
  }
}
` as GeneratedQuery<
  APITypes.GetGradesForSaleQueryVariables,
  APITypes.GetGradesForSaleQuery
>;
export const getGravityMachineLotCounts =
  /* GraphQL */ `query GetGravityMachineLotCounts(
  $startDate: AWSDate!
  $endDate: AWSDate!
) {
  getGravityMachineLotCounts(
    startDate: $startDate
    endDate: $endDate
  ) {
    day
    count
  }
}
` as GeneratedQuery<
    APITypes.GetGravityMachineLotCountsQueryVariables,
    APITypes.GetGravityMachineLotCountsQuery
  >;

export const getAllGradeBoundaries =
  /* GraphQL */ `query GetAllGradeBoundaries {
  getAllGradeBoundaries {
    grade
    lower_bound
    upper_bound
  }
}
` as GeneratedQuery<
    APITypes.GetAllGradeBoundariesQueryVariables,
    APITypes.GetAllGradeBoundariesQuery
  >;

export const listMigrationTemplates =
  /* GraphQL */ `query ListMigrationTemplates {
  listMigrationTemplates {
    templateId
	  templateName
    createdBy
    createdAt
    sourceConfig {
      name
      tenant_id
      __typename
    }
    destinationConfig {
      name
      tenant_id
      __typename
    }
    tablesConfig {
      name
      primary_key
      conflict_strategy
      query
      __typename
    }
    __typename
  }
}
` as GeneratedQuery<
    APITypes.ListMigrationTemplatesQueryVariables,
    APITypes.ListMigrationTemplatesQuery
  >;

export const listRecentMigrationLogs =
  /* GraphQL */ `query ListRecentMigrationLogs($limit: Int, $nextToken: String) {
  listRecentMigrationLogs(limit: $limit, nextToken: $nextToken) {
    items {
      logId
      transferId
      triggeredBy
      sourceConfig {
        name
        tenant_id
        __typename
      }
      destinationConfig {
        name
        tenant_id
        __typename
      }
      tableName
      primaryKey
      conflictStrategy
      query
      state
      recordedAt
      message
      __typename
    }
    nextToken
  }
}
` as GeneratedQuery<
    APITypes.ListRecentMigrationLogsQueryVariables,
    APITypes.ListRecentMigrationLogsQuery
  >;

export const listEnvironmentNames = /* GraphQL */ `
  query ListEnvironmentNames {
    listEnvironmentNames {
      name
    }
  }
`;
